import {Component, Input, OnInit} from '@angular/core';
import { ModalController} from '@ionic/angular';
import {ActivatedRoute} from "@angular/router";
import {OfferInfo} from "~/app/core/model/offer-info";
import {CoreService} from "~/app/core/core.service";
import {AddressInfo} from "~/app/core/model/address-info";
import {LocationInfo} from "~/app/core/model/location-info";
import {AddressDistance} from "~/app/core/model/address-distance";
import * as moment from "moment";

@Component({
  selector: 'app-modal',
  templateUrl: './congratulationsDialog.component.html',
  styleUrls: ['./congratulationsDialog.component.scss'],
})

export class CongratulationsDialogComponent implements OnInit {

  @Input() offer: OfferInfo;

  constructor(
    public modalCtrl: ModalController,
  ) {
  }

  ngOnInit() {

  }

  dismissDialog(yesOrNo: boolean) {
    // TODO api call to mark purchased something yes/no
    // this.core.api.offer_???(this.offer.id);
    this.modalCtrl.dismiss(yesOrNo);
  }
}
